import { render, staticRenderFns } from "./DecorationSubTitleSmall.vue?vue&type=template&id=2ccdc88b&scoped=true&"
import script from "./DecorationSubTitleSmall.vue?vue&type=script&lang=js&"
export * from "./DecorationSubTitleSmall.vue?vue&type=script&lang=js&"
import style0 from "./DecorationSubTitleSmall.vue?vue&type=style&index=0&id=2ccdc88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccdc88b",
  null
  
)

export default component.exports